import { render } from "./GerarDocumento.vue?vue&type=template&id=d5c9b196&scoped=true"
import script from "./GerarDocumento.vue?vue&type=script&lang=js"
export * from "./GerarDocumento.vue?vue&type=script&lang=js"

import "./GerarDocumento.vue?vue&type=style&index=0&id=d5c9b196&scoped=true&lang=css"

import exportComponent from "/builds/ssp/csmpmview/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d5c9b196"]])

export default __exports__